<script setup>
import { pushToDataLayerDirectly } from '@/ui/scripts/analytics/analytics.methods';
import { ProjectsAlphabetLink } from '@/app/components';

const emit = defineEmits(['click']);

defineProps({
  projects: {
    required: true,
  },
});

function clickHandler(letter) {
  if (letter.locations.length > 0) {
    pushToDataLayerDirectly({
      event: 'project_list_index',
      link_text: letter.region,
    });
    emit('click', letter.region);
  }
}
</script>

<template>
  <ol class="c-projects-alphabet">
    <li v-for="letter in projects" :key="letter.id" class="c-projects-alphabet__item">
      <ProjectsAlphabetLink
        @click="clickHandler(letter)"
        :id="letter.id"
        :linkActive="letter.locations.length > 0"
        class="c-projects-alphabet__link"
      >
        {{ letter.region }}
      </ProjectsAlphabetLink>
    </li>
  </ol>
</template>

<style lang="scss">
@import '@/ui/styles/functions/functions';
@import '@/ui/styles/mixins/buttons';
@import '@/ui/styles/settings/colors';

.c-projects-alphabet {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0;
  padding: 0;
  list-style: none;
}

.c-projects-alphabet__item {
  display: flex;
  justify-content: center;
  align-items: center;
}

.c-projects-alphabet__link {
  @include removeDefaultButtonStyling();
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: rem(44px);
  min-height: rem(44px);
  color: $color-brand-one;
  font-size: #{'clamp(1.125rem, 1.647vw + 0.796rem, 2rem)'};
  text-decoration: underline;
  cursor: pointer;

  &[aria-disabled='true'] {
    color: $ssen-dark-grey;
    text-decoration: none;
    cursor: not-allowed;
  }
}
</style>
